let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("35LYU")).then(() => parcelRequire('lm6LN'));